"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _redux = require("redux");
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _reactRedux = require("react-redux");
var _assets = require("@mulesoft/exchange-ui-portals-store/lib/domains/assets");
var _ShareToPublicPortalPanel = _interopRequireDefault(require("./ShareToPublicPortalPanel"));
var _utils = require("./utils");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ShareToPublicPortalPanelWrapper = function ShareToPublicPortalPanelWrapper(props) {
  var isPublicPortalEnabled = (0, _exchangeReactHooks.useIsPublicPortalEnabled)();
  return /*#__PURE__*/_react.default.createElement(_ShareToPublicPortalPanel.default, (0, _extends2.default)({}, props, {
    isPublicPortalEnabled: isPublicPortalEnabled
  }));
};
var mapStateToProps = function mapStateToProps(state, _ref) {
  var asset = _ref.asset;
  return {
    versionGroups: _assets.selectors.assetVersionGroups(state, asset) || [],
    isAdding: _assets.selectors.isAddingToPublicPortal(state),
    isLoading: _assets.selectors.isLoadingVersionGroups(state) || _assets.selectors.isLoadingVersionsDependencies(state) || _assets.selectors.isLoadingVersionsDependents(state)
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch, _ref2) {
  var asset = _ref2.asset,
    closeModal = _ref2.closeModal,
    trackEvent = _ref2.trackEvent;
  return {
    onComponentMounted: function onComponentMounted(versionGroups) {
      dispatch(_assets.actions.getVersionGroups(asset));
      if (asset.type === 'api-group') {
        // TODO: sorry for this, I promise to find a better solution later
        dispatch(_assets.actions.getVersionsDependencies(asset));
      } else {
        dispatch(_assets.actions.getVersionsDependents(_objectSpread(_objectSpread({}, asset), {}, {
          versionGroups: versionGroups.map(function (_ref3) {
            var versionGroup = _ref3.versionGroup;
            return versionGroup;
          })
        })));
      }
    },
    onUpdateVisibility: function () {
      var _onUpdateVisibility = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee(_ref4) {
        var currentVersionGroups, updatedVersionGroups, publicVersionGroups, visibilityActions;
        return _regenerator.default.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              currentVersionGroups = _ref4.currentVersionGroups, updatedVersionGroups = _ref4.updatedVersionGroups;
              publicVersionGroups = updatedVersionGroups.filter(function (_ref5) {
                var isPublic = _ref5.isPublic;
                return isPublic;
              }).map(function (_ref6) {
                var versionGroup = _ref6.versionGroup;
                return versionGroup;
              });
              _context.next = 1;
              return dispatch(_assets.actions.updateVisibility(_objectSpread(_objectSpread({}, asset), {}, {
                publicVersionGroups: publicVersionGroups
              })));
            case 1:
              visibilityActions = (0, _utils.getVisibilityUpdateTrackingActions)({
                asset: asset,
                currentVersionGroups: currentVersionGroups,
                updatedVersionGroups: updatedVersionGroups
              });
              visibilityActions.forEach(function (visibilityAction) {
                return trackEvent.apply(void 0, (0, _toConsumableArray2.default)(visibilityAction));
              });
              closeModal();
              dispatch(_assets.actions.resetVersionsDependents(asset));
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function onUpdateVisibility(_x) {
        return _onUpdateVisibility.apply(this, arguments);
      }
      return onUpdateVisibility;
    }()
  };
};
var _default = exports.default = (0, _redux.compose)(_exchangeReactHooks.withAnalytics, _exchangeReactHooks.withModal, _exchangeReactHooks.withConfig, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(ShareToPublicPortalPanelWrapper);
//# sourceMappingURL=ShareToPublicPortalPanel.container.js.map